// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__25-i7","icon":"SortAdornment_icon__kusNc","up":"SortAdornment_up__13yhk","down":"SortAdornment_down__1sPqZ","active":"SortAdornment_active__1bGp1"};